const messages: Record<string, string> = {
	'loader.loading': 'Cargando datos...',
	'loader.error':
		'No se ha podido cargar la información. Por favor, inténtalo de nuevo más tarde...',
	'connectionError.title': 'Error de conexión',
	'connectionError.description': 'Error de conexión. Por favor, adjunta la imagen de nuevo.',
	'mainError.tryAgain': 'Inténtalo de nuevo',
	'landing.headline.policyCheck': 'Bienvenido/a',
	'landing.paragraph': 'Estás a tres pasos de finalizar el proceso',
	'landing.stepDescription.fourAdditionalPictures': 'Sube las fotos',
	'landing.stepDescription.fourDiagonalPerspectives': 'Haz las fotos que necesitamos',
	'landing.stepDescription.feedback': 'Danos tu opinión',
	termsAndConditionsLinkDescription: '0',
	termsAndConditionsLink: 'Acepto los términos y condiciones',
	'button.start': 'Iniciar',
	'landing.aboutPolicyCheck': ' ',
	'landing.additional-informations-section.title':
		'Antes de iniciar la verificación de tu vehículo, comprueba que:',
	'landing.additional-informations-section.text':
		'<ul><li>Tienes las llaves y el permiso de circulación a mano</li><li>Estás en un lugar con buena luz y red móvil / Internet</li><li>Puedes acceder al vehículo desde todos los ángulos y todas las ventanillas laterales están cerradas. </li></ul>',
	'landing.additional-informations-section.text.motorbike': ' ',
	'landing.termsAndConditionsLink':
		'Por favor, acepte los términos y condiciones antes de continuar.',
	'chooseLang.headline': 'Elige tu idioma preferido',
	'button.close': 'Cerrar',
	'blockedByDevice.headline': 'No es posible abrir PolicyCheck desde un ordenador',
	'blockedByDevice.description':
		'No es posible abrir PolicyCheck desde un ordenador. La plataforma de Policycheck realiza verificaciones digitales solo desde el teléfono movil. Para continuar, por favor, abre el enlace de PolicyCheck desde un teléfono.',

	'vehicleImages.overviewPhotos': 'Vista general del vehículo',
	'vehicleImages.overviewPhotos.subtitle': 'Haz las fotos de tu vehiculo',
	'vehicleImages.description':
		'Haz una foto de tu vehículo en diagonal desde la parte delantera izquierda y derecha y desde la parte trasera izquierda y derecha. La matrícula se tiene que ver en todas las imágenes.',
	'vehicleImages.description.motorbike': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Foto diagonal delantera izquierda',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Foto diagonal trasera izquierda',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Foto diagonal trasera derecha',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Foto diagonal delantera derecha',
	'button.next': 'Siguiente',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Foto de ejemplo',
	'imageRecognitionMismatchModal.headline': 'Comprueba que has adjuntado la foto correcta',
	'button.continue': 'Continuar',
	'button.backchangeImage': 'Atrás y cambiar foto',
	'completeVehicleImagesModal.headline': 'Ayuda',
	'completeVehicleImagesModal.description': 'Por favor adjunta las siguientes fotos',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Foto diagonal delantera izquierda',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Foto diagonal trasera derecha',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Foto diagonal trasera izquierda',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Foto diagonal delantera derecha',
	'vehicleImages.leftFrontOverview': 'Foto diagonal delantera izquierda',
	'vehicleImages.leftRearOverview': 'Foto diagonal trasera izquierda',
	'vehicleImages.rightRearOverview': 'Foto diagonal trasera derecha',
	'vehicleImages.rightFrontOverview': 'Foto diagonal delantera derecha',
	'button.changeImage': 'Cambiar la foto',
	'button.deleteImage': 'Eliminar la foto',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Foto de ejemplo - Foto diagonal delantera izquierda',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Foto de ejemplo - Foto diagonal trasera derecha',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Foto de ejemplo - Foto diagonal delantera derecha',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Foto de ejemplo - Foto diagonal trasera izquierda',
	'fourAdditionalPictures.title': 'Fotos adicionales',
	'fourAdditionalPictures.overallDashboard.title': 'Salpicadero del vehículo',
	'fourAdditionalPictures.overallDashboard.description':
		'Haz una foto completa del salpicadero de tu vehículo',
	'fourAdditionalPictures.mileage.title': 'Cuentakilómetros',
	'dashboardMileage.dashboard.paragraph':
		'Haz una foto de los kilómetros recorridos. Si tu vehículo tiene una pantalla digital, enciéndala.',
	'dashboardMileage.paragraph.first': 'Indica el kilometraje de tu vehículo',
	'dashboardMileage.placeholder': 'Por ejemplo: 150.000 km',
	'fourAdditionalPictures.windshield.title': 'Parabrisas delantero del vehículo',
	'fourAdditionalPictures.windshield.description':
		'Haz una foto completa del parabrisas delantero de tu vehículo',
	'fourAdditionalPictures.vin.title': 'Número de bastidor del vehículo',
	'fourAdditionalPictures.vin.description':
		'Haz una foto del número de bastidor de tu vehículo. Puedes encontrar este dato: debajo del capó, en el motor, bajo el asiento del copiloto, salpicadero o puerta del conductor.',
	'overallDashboardImage.title': 'Imagen general del salpicadero',
	'dashboardMileage.dashboard.title': 'Foto del kilometraje',
	'windshieldImage.title': 'Foto del parabrisas',
	'vinPicture.title': 'Foto del número de bastidor',
	'completeFourAdditionalPicturesModal.headline': 'Ayuda',
	'completeFourAdditionalPicturesModal.description': 'Por favor, adjunta la siguiente información:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		'Foto del salpicadero del vehículo',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Foto del kilometraje',
	'completeDashboardMileageModal.hasValidMileage': 'Kilometraje del vehículo',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Foto del número de bastidor del vehículo',
	'completeFourAdditionalPicturesModal.hasWindshieldImage':
		'Foto del parabrisas delantero del vehículo',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle':
		'Foto de ejemplo - Foto del salpicadero del vehículo',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Foto de ejemplo - Foto del kilometraje',
	'fourAdditionalPictures.windshield.exampleModalTitle':
		'Foto de ejemplo - Foto del parabrisas delantero del vehículo',
	'fourAdditionalPictures.vin.exampleModalTitle':
		'Foto de ejemplo - Foto del número de bastidor del vehículo',
	'fourAdditionalPicturesExampleModal.button.close': 'Cerrar',

	'fourAdditionalDocuments.title': 'Detalles del vehículo',
	'fourAdditionalDocuments.RegistrationDocument.title':
		'Foto del permiso de circulación (por delante)',
	'fourAdditionalDocuments.RegistrationDocument.description':
		'Haz una foto del permiso de circulación (por delante)',
	'image.locked.RegistrationDocument':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de la imagen de Permiso de Circulación.',
	'fourAdditionalDocuments.RegistrationDocumentInside.title':
		'Foto del permiso de circulación (por detrás)',
	'fourAdditionalDocuments.RegistrationDocumentInside.description':
		'Haz una foto del permiso de circulación (por detrás)',
	'image.locked.RegistrationDocumentInside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de la imagen de Permiso de Circulación.',
	'fourAdditionalDocuments.DniInside.title': ' ',
	'fourAdditionalDocuments.DniInside.description': ' ',
	'image.locked.DniInside': ' ',
	'fourAdditionalDocuments.DniOutside.title': ' ',
	'fourAdditionalDocuments.DniOutside.description': ' ',
	'image.locked.DniOutside': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.title':
		'Foto de la ficha técnica del vehículo (por delante)',
	'fourAdditionalDocuments.VehicleDatasheetOutside.description':
		'Haz una foto de la ficha técnica del vehículo (por delante)',
	'image.locked.VehicleDatasheetInside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de la imagen de Ficha técnica.',
	'fourAdditionalDocuments.VehicleDatasheetInside.title':
		'Foto de la ficha técnica del vehículo (por detrás)',
	'fourAdditionalDocuments.VehicleDatasheetInside.description':
		'Haz una foto de la ficha técnica del vehículo (por detrás)',
	'image.locked.VehicleDatasheetOutside':
		'Debido a la protección de datos personales, se ha bloqueado la descarga de la imagen de Ficha técnica.',
	'fourAdditionalDocuments.DriverLicenseInside.title': ' ',
	'fourAdditionalDocuments.DriverLicenseInside.description': ' ',
	'image.locked.DriverLicenseInside': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.title': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.description': ' ',
	'image.locked.DriverLicenseOutside': ' ',
	'completeFourAdditionalDocumentsModal.headline': 'Ayuda',
	'completeFourAdditionalDocumentsModal.description':
		'Por favor, adjunta la siguiente información:',
	'fourAdditionalDocuments.RegistrationDocument.headline':
		'Foto del permiso de circulación (por delante)',
	'fourAdditionalDocuments.RegistrationDocumentInside.headline':
		'Foto del permiso de circulación (por detrás)',
	'fourAdditionalDocuments.DniInside.headline': ' ',
	'fourAdditionalDocuments.DniOutside.headline': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.headline':
		'Foto de la ficha técnica del vehículo (por delante)',
	'fourAdditionalDocuments.VehicleDatasheetInside.headline':
		'Foto de la ficha técnica del vehículo (por detrás)',
	'fourAdditionalDocuments.DriverLicenseInside.headline': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.headline': ' ',
	'fourAdditionalDocuments.RegistrationDocument.exampleModalTitle':
		'Foto del permiso de circulación (por delante) - ejemplo',
	'fourAdditionalDocuments.RegistrationDocumentInside.exampleModalTitle':
		'Foto del permiso de circulación (por detrás) - ejemplo',
	'fourAdditionalDocuments.DniInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DniOutside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.VehicleDatasheetOutside.exampleModalTitle':
		'Foto de la ficha técnica del vehículo (por delante) - ejemplo',
	'fourAdditionalDocuments.VehicleDatasheetInside.exampleModalTitle':
		'Foto de la ficha técnica del vehículo (por detrás) - ejemplo',
	'fourAdditionalDocuments.DriverLicenseInside.exampleModalTitle': ' ',
	'fourAdditionalDocuments.DriverLicenseOutside.exampleModalTitle': ' ',

	'feedback.headline.policyCheck': 'Fotos recibidas correctamente',
	'feedback.description': ' ',
	'feedback.rating.policyCheck':
		'¿Con cuántas estrellas calificarías tu experiencia con el proceso de verificación digital, siendo 5 la mejor puntuación?',
	'feedback.yourOpinion': '¿Tienes algún comentario?',
	'feedback.button.send': 'Enviar',
	'waitForAudit.thankYou': 'Agradecemos tu opinión',
	'waitForAudit.description.damageFound': 'Gracias por confiar en Allianz',
	'thanks.headline.first': 'Gracias!',
	'thanks.paragraph.first': 'Gracias por confiar en Allianz',

	'invalidFile.size.title': 'Tamaño de archivo incorrecto',
	'invalidFile.size.description': 'El tamaño de la imagen es mayor que el máximo requerido.',
	'invalidFile.extension.title': 'Este tipo de archivo no es válido',
	'invalidFile.extension.description':
		'Este tipo de archivo no es válido. Los formatos aceptados en este caso serían: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
